import type {ButtonProps} from '@mui/material/Button';
import Button from '@mui/material/Button';
import {useLogout} from '@refinedev/core';
import {useTranslation} from 'react-i18next';

// ----------------------------------------------------------------------

export function SignOutButton({sx, ...other}: ButtonProps) {
  const {mutate: logout} = useLogout();
  const {t} = useTranslation();

  return (
    <Button fullWidth variant="soft" size="large" color="error" onClick={() => logout()} sx={sx} {...other}>
      {t('buttons.logout')}
    </Button>
  );
}
